import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '@shared/authentication/authentication.service';

export const blueprintsGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const auth = inject(AuthenticationService);

  return auth
    .ensureProfile()
    .pipe(map((profile) => (profile?.anonymous === false ? true : router.parseUrl('/login'))));
};

export const objectEditorGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const auth = inject(AuthenticationService);

  return auth
    .ensureProfile()
    .pipe(map((profile) => (true)));
};
